import React from "react";
import NumberFormat from 'react-number-format';

export default function (props) {
    const { settings, value } = props;
    
    return (
        <NumberFormat
            className="money-field"
            value={value.toFixed(2)}
            isNumericString={true}
            displayType={'text'}
            thousandSeparator={settings.currencyGroupSeparator}
            decimalSeparator={settings.currencyDecimalSeparator}
            prefix={`${settings.currencySymbol} `}
        />
    );
}
 